// extracted by mini-css-extract-plugin
export default {"commentStyle":"Comment_commentStyle__NAfaQ","commentDiv":"Comment_commentDiv__WO7op"};